import { useMemo } from 'react';
import { useAppSelector } from '../useAppSelector';

export const useParentOffice = () => {
  const currentUser = useAppSelector((state) => state.user.user);
  const selectedOfficeId = useAppSelector((state) => state.user.selectedOfficeId);

  const isParentOffice = useMemo(
    () => currentUser?.id === selectedOfficeId,
    [currentUser?.id, selectedOfficeId],
  );

  return {
    office: currentUser,
    isParentOffice,
  };
};
